import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { FormatDetectionStatusPipe } from '../../pipes/detection.pipe';
import { Comment, CommentChange } from '../../../models/comment';
import { interval } from 'rxjs';
import { map, startWith } from 'rxjs/operators';


@Component({
    selector: 'comment-system',
    templateUrl: './comment-system.component.html',
    styleUrls: ['./comment-system.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CommentSystemComponent {

  @Input({ required: true }) comment!: Comment;
  @Input() showAuthor = true;
  @Input() showDate = true;

  readonly refreshSince$ = interval(10000).pipe(
    startWith(0),
    map(() => Date.now())
  );

  constructor(private translocoService: TranslocoService,
              private detectionStatusPipe: FormatDetectionStatusPipe) {}

  get changes(): CommentChange[] {
    return this.comment?.metadata?.changes ?? [];
  }

  getFieldLabel(field: string): string {
    return this.translocoService.translate(field);
  }

  formatValue(field: string, value: unknown): string {
    if (value === null || value === undefined || value === '') {
      return this.translocoService.translate('comments.values.empty');
    }

    switch (field) {
      case 'status':
        return this.detectionStatusPipe.transform(Number(value));
      case 'emergency_label':
        return String(value);
      default:
        return this.translocoService.translate(String(value));
    }
  }

  hasOldValue(change: CommentChange): boolean {
    return change.old !== undefined;
  }
}
